import ExportsPage, { exportsQuery } from "@app/pages/exports/exports-page";
import type { exportsPage_Query } from "@app/queries/exportsPage_Query.graphql";
import { environment } from "@app/relay/relay-environment";
import { pageHead } from "@app/lib/page-title";
import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { loadQuery } from "react-relay";

export const Route = createFileRoute("/_authed/exports")({
  // network-only: arriving here straight after pressing Generate must show the
  // run that was just queued, not a store snapshot from before it. Exempt from
  // the global date-range lens — an export covers whatever it was taken over, so
  // a lens on this list would describe nothing on it.
  loader: () =>
    loadQuery<exportsPage_Query>(
      environment,
      exportsQuery,
      {},
      { fetchPolicy: "network-only" }
    ),
  head: () => pageHead("Exports"),
  component: ExportsRoute,
});

function ExportsRoute() {
  const queryRef = Route.useLoaderData();

  return (
    <ErrorBoundary
      fallback={<div className="p-6 text-red-500">Error loading exports</div>}
    >
      <Suspense
        fallback={<div className="p-6 text-gray-500">Loading exports…</div>}
      >
        <ExportsPage queryRef={queryRef} />
      </Suspense>
    </ErrorBoundary>
  );
}
